import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M9.871 10.587h4.289v1.688H9.871v-1.688zM11.033 15.251h1.887l.595-2.039H10.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.001 3.757A8.242 8.242 0 003.758 12a8.242 8.242 0 1016.484-.002 8.24 8.24 0 00-8.241-8.241zm4.221 12.291H7.738v-.797h2.098l-.633-2.039h-.738V9.649h7.055v3.563h-.806l-.595 2.039h2.105v.797zm.024-7.289H7.785v-.938h8.461v.938z"
})), 'DoubanRing');